<script>
// Kept as a no-op for existing layout imports. Account-wide billing banners are retired.
export default {
  name: 'AgencyNumberApprovalNotice',
  render () { return null }
}
</script>
